import { Component, OnInit, HostListener } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { GaleriaVideo } from 'src/app/models/galeria-video.model';
import { LinhaProduto } from 'src/app/models/linha-produto.model';
import { DataService } from 'src/app/services/data.service';
import { GlobalService } from 'src/app/services/global.service';
import { HelperService } from 'src/app/services/helper.service';
import { VideoService } from 'src/app/services/video.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  active: boolean = false;
  menuOpen: boolean = false;

  linhas: LinhaProduto[] = [];

  videos: GaleriaVideo[] = [];
  videoSelected: GaleriaVideo = new GaleriaVideo();

  @HostListener('window:scroll', [])
  handleScroll(): void {
    const windowScroll = window.pageYOffset;
    if (windowScroll >= 50) {
      this.active = true;
    } else {
      this.active = false;
    }
  }

  constructor(
    public _video: VideoService,
    public _helper: HelperService,

    public global: GlobalService,
    public _data: DataService,
    public router: Router,
    public sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.buscarLinhas();
    this.buscarVideos();
  }

  buscarLinhas() {
    this._data
      .buscarLinhas(-99, -99)
      .subscribe((res: LinhaProduto[]) => (this.linhas = res));
  }

  goToVideos(e: Event, targetId: string) {
    e.preventDefault();

    this.router.navigate(['/inicio', this.linhas[0].slug]).then(() => {
      // Aguarda a renderização com setTimeout ou usando Angular Zone
      setTimeout(() => {
        const el = document.getElementById(targetId);
        if (el) {
          const yOffset = -120;
          const y =
            el.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 100); // Pequeno delay para garantir que o DOM está pronto
    });
  }

  buscarVideos() {
    this._data.buscarVideos(-99, -99).subscribe((res: GaleriaVideo[]) => {
      if (!res.length) return;

      this.videos = res.map((video) => {
        video.videoId = this._helper.getYoutubeId(video.video);
        video.link = this.sanitizer.bypassSecurityTrustResourceUrl(
          `https://www.youtube.com/embed/${video.videoId}`
        );
        return video;
      });

      this.videoSelected = this.videos[0];
      console.log('Vídeos carregados:', this.videos);
    });
  }

  scrollTo(e: Event, targetId: string) {
    e.preventDefault();
    const el = document.getElementById(targetId);
    if (el) {
      const yOffset = -120;
      const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }
}
